import React, { memo } from 'react';
// mui components
import { Grid, Typography } from '@mui/material';
// Component
import ActionButton from 'components/buttons';
// icons
import LogoPrimary from 'assets/icons/logo_dark.svg';
import SupportIcon from 'assets/icons/error-msg.svg';
import ErrorPageIllustration from 'assets/icons/404.svg';
import { styles } from './styles';

const DeploymentPage: React.FC = () => {
  return (
    <Grid sx={styles.container}>
      <Grid sx={styles.logoContainer}>
        <LogoPrimary width={130} height={25} />
      </Grid>

      <Grid sx={styles.content}>
        <ErrorPageIllustration />

        <Typography sx={styles.title}>Uh-oh! Something went wrong.</Typography>
        <Typography sx={styles.description}>
          We’re already on it — our team has been notified. Try refreshing <br />
          the page, or reach out to support if the issue continues.
        </Typography>

        <Grid container sx={styles.buttonWrapper}>
          <ActionButton
            label="Contact Support"
            variant="tertiary"
            onClick={() => {
              window.open('https://support.builderpad.com', '_blank');
            }}
            startIcon={<SupportIcon />}
            size="small"
          />
        </Grid>
      </Grid>
    </Grid>
  );
};

export default memo(DeploymentPage);
